import NextLink       from "next/link";
import { useRouter }  from "next/router";
import { forwardRef } from "react";

import { useGetIsWebview }   from "_common/hooks/global";
import { removeEmptyFields } from "_common/utils";

const Link = forwardRef ( ( props, ref ) => {
	const {
		href,
		children,
		...rest
	} = props;

	const router             = useRouter ();
	const isWebview          = useGetIsWebview ();
	const defaultQueryParams = removeEmptyFields ( {
		"platform"     : router.query.platform,
		"userId"       : router.query.userId,
		"deviceId"     : router.query.deviceId,
		"appVersion"   : router.query.appVersion,
		"accessToken"  : router.query.accessToken,
		"refreshToken" : router.query.refreshToken,
		"tokenType"    : router.query.tokenType,
		"theme"        : router.query.theme,
		"type"         : router.query.type,
		"from"         : router.query.from
	} );

	let urlObj = href;

	if ( isWebview )
		if ( typeof href !== "string" && typeof href.query !== "string" )
			urlObj = {
				pathname : href.pathname,
				query    : {
					...href.query,
					...defaultQueryParams
				}
			};

	return (
		<NextLink
			ref      = { ref }
			href     = { urlObj }
			passHref = { true }
			{ ...rest }
		>
			{children}
		</NextLink>
	);
} );

Link.displayName = "link";

export default Link;
